import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey } from '../hooks/useSearchActiviteitenForEntity'
import { completeActiviteitForEntity } from '../services/completeActiviteitForEntity'

export { useCompleteActiviteitForEntity }

const useCompleteActiviteitForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: completeActiviteitForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      successAlert('Activiteit successvol afgehandeld')
    },
  })
}
